module.exports = __webpack_public_path__ + "static/img/17.6277a5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/17.png
// module id = eylS
// module chunks = 0